<template>
  <section class="points-rule">
    <section class="searchbox">
      <form action="#" method="get" class="form-inline form-float">
        <div class="form-group">
          <label>规则名称:</label>
          <input
            v-model.trim="search.integralName"
            class="form-control"
            type="text"
            placeholder
            size="12"
          />
        </div>
        <div class="form-group others">
          <span class="search_btn">
            <el-button
              @click="searchList"
              type="button"
              class="btn btn-primary"
              id="search_btn"
              :loading="loading"
            >
              查询
            </el-button>
          </span>
          <span class="add_btn">
            <button type="button" class="btn btn-default" @click="addOrEdit()">
              添加
            </button>
          </span>
        </div>
      </form>
    </section>
    <section class="table-box list-right">
      <el-table
        border
        height="100%"
        v-loading="loading"
        :data="dataList"
        :header-cell-style="tableHeaderStyle"
        :cell-style="styleObj"
      >
        <el-table-column prop="integralName" label="规则名称"></el-table-column>
        <el-table-column prop="consumeType" label="规则类型"></el-table-column>
        <el-table-column label="使用场景">
          <template slot-scope="scope">
            {{
              scope.row.integralSence === "get"
                ? "积分获取"
                : scope.row.integralSence === "use"
                ? "积分使用"
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column prop="integralStatus" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.integralStatus === 'created'">已创建</span>
            <span v-if="scope.row.integralStatus === 'issued'">已发布</span>
            <span v-if="scope.row.integralStatus === 'stoped'">已废除</span>
          </template>
        </el-table-column>
        <el-table-column prop="exchangeRate" label="兑换率"></el-table-column>
        <el-table-column label="欠费是否可用">
          <template slot-scope="scope">
            {{ scope.row.arrearsUseFlag === "y" ? "可用" : "不可用" }}
          </template>
        </el-table-column>
        <el-table-column label="是否需要认证">
          <template slot-scope="scope">
            {{
              scope.row.needUserRegisterFlag === "y" ? "需认证" : "不需要认证"
            }}
          </template>
        </el-table-column>
        <el-table-column
          width="350px"
          prop="attr1"
          label="备注"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column show-overflow-tooltip label="操作" width="200px">
          <template slot-scope="scope">
            <button
              class="edit"
              type="button"
              @click="addOrEdit(scope.row.integralId)"
              v-if="scope.row.integralStatus === 'created'"
            >
              修改
            </button>
            <button
              class="edit"
              type="button"
              @click="onOperBtn(scope.row, 'issue')"
              v-if="scope.row.integralStatus === 'created'"
            >
              发布
            </button>
            <button
              class="edit"
              type="button"
              @click="onOperBtn(scope.row, 'stop')"
              v-if="
                scope.row.integralStatus === 'issued' ||
                  scope.row.integralStatus === 'created'
              "
            >
              废除
            </button>
          </template>
        </el-table-column>
      </el-table>
    </section>
    <Page
      v-on:pagination="receivePaginationData"
      v-bind:pageObj="pageObj"
    ></Page>
    <points-rule-update
      v-if="isShowUpdate"
      v-on:update-callback="updateCallback"
      v-bind:integralId="integralId"
    ></points-rule-update>
  </section>
</template>
<script>
import { queryPointsRuleList, pointsRuleOper } from "@/api/url";
import Page from "@/page/commons/page";
import PointsRuleUpdate from "./points-rule-update";
export default {
  name: "points-rule",
  data: () => {
    return {
      dataList: [],
      loading: false,
      search: { integralName: "", pageNumber: 1, pageSize: 10 },
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      pageObj: {},
      isShowUpdate: false,
      integralId: "",
    };
  },
  components: {
    Page,
    PointsRuleUpdate,
  },
  mounted() {
    this.getPointsRuleList(this.search.pageNumber);
  },

  methods: {
    getPointsRuleList(curPage) {
      this.loading = true;
      this.$get(queryPointsRuleList(), {
        page: curPage,
        limit: this.search.pageSize,
        integralName: this.search.integralName
          ? this.search.integralName
          : null,
      })
        .then((res) => {
          if (res?.status !== 200) return;
          this.dataList = res?.data?.rows || [];
          const pageObj = {
            curIndex: res.data.offset,
            rowsCount: res.data.total,
          };

          this.pageObj = { ...pageObj };
        })
        .finally(() => {
          this.loading = false;
        });
    },
    searchList() {
      this.search.pageNumber = 1;
      this.getPointsRuleList(this.search.pageNumber);
    },
    addOrEdit(id) {
      id ? (this.integralId = id) : (this.integralId = "");
      this.isShowUpdate = true;
    },
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;

      this.getPointsRuleList(this.search.pageNumber);
    },
    updateCallback(v) {
      this.isShowUpdate = false;
      v === "add-success"
        ? (() => {
            this.search.pageNumber = 1;
            this.getPointsRuleList(this.search.pageNumber);
          })()
        : v === "edit-success"
        ? this.getPointsRuleList(this.pageObj.curIndex)
        : null;
    },
    onOperBtn(row, integralStatus) {
      const { integralId } = row;
      this.$postRequest(
        `${pointsRuleOper()}?integralId=${integralId}&operName=${integralStatus}`
      ).then((res) => {
        if (res?.status != 200) {
          this.$message.error("操作失败");
          return;
        }
        this.$message.success("操作成功");
        this.getPointsRuleList(this.pageObj.curIndex);
      });
    },
  },
};
</script>
<style scoped></style>
